import { TYPES } from "../constants";

const TypeTabs = ({ activeType, setActiveType }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {TYPES.map((t) => {
        const active = activeType === t.key;
        return (
          <button
            key={t.key}
            onClick={() => setActiveType(t.key)}
            type="button"
            className={`rounded-xl px-4 py-3 min-h-[44px] text-sm font-medium transition touch-manipulation ${
              active
                ? "bg-[#e0d8c3] text-[#000000]"
                : "bg-white border border-[#a6a6a6]/50 text-[#000000] hover:bg-[#e0d8c3]/30"
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default TypeTabs;
